<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6547_29076)">
      <g clip-path="url(#clip1_6547_29076)">
        <path
          d="M20 11.8008C22.6719 11.8008 22.9883 11.8125 24.0391 11.8594C25.0156 11.9023 25.543 12.0664 25.8945 12.2031C26.3594 12.3828 26.6953 12.6016 27.043 12.9492C27.3945 13.3008 27.6094 13.6328 27.7891 14.0977C27.9258 14.4492 28.0898 14.9805 28.1328 15.9531C28.1797 17.0078 28.1914 17.3242 28.1914 19.9922C28.1914 22.6641 28.1797 22.9805 28.1328 24.0313C28.0898 25.0078 27.9258 25.5352 27.7891 25.8867C27.6094 26.3516 27.3906 26.6875 27.043 27.0352C26.6914 27.3867 26.3594 27.6016 25.8945 27.7813C25.543 27.918 25.0117 28.082 24.0391 28.125C22.9844 28.1719 22.668 28.1836 20 28.1836C17.3281 28.1836 17.0117 28.1719 15.9609 28.125C14.9844 28.082 14.457 27.918 14.1055 27.7813C13.6406 27.6016 13.3047 27.3828 12.957 27.0352C12.6055 26.6836 12.3906 26.3516 12.2109 25.8867C12.0742 25.5352 11.9102 25.0039 11.8672 24.0313C11.8203 22.9766 11.8086 22.6602 11.8086 19.9922C11.8086 17.3203 11.8203 17.0039 11.8672 15.9531C11.9102 14.9766 12.0742 14.4492 12.2109 14.0977C12.3906 13.6328 12.6094 13.2969 12.957 12.9492C13.3086 12.5977 13.6406 12.3828 14.1055 12.2031C14.457 12.0664 14.9883 11.9023 15.9609 11.8594C17.0117 11.8125 17.3281 11.8008 20 11.8008ZM20 10C17.2852 10 16.9453 10.0117 15.8789 10.0586C14.8164 10.1055 14.0859 10.2773 13.4531 10.5234C12.793 10.7812 12.2344 11.1211 11.6797 11.6797C11.1211 12.2344 10.7813 12.793 10.5234 13.4492C10.2773 14.0859 10.1055 14.8125 10.0586 15.875C10.0117 16.9453 10 17.2852 10 20C10 22.7148 10.0117 23.0547 10.0586 24.1211C10.1055 25.1836 10.2773 25.9141 10.5234 26.5469C10.7813 27.207 11.1211 27.7656 11.6797 28.3203C12.2344 28.875 12.793 29.2188 13.4492 29.4727C14.0859 29.7188 14.8125 29.8906 15.875 29.9375C16.9414 29.9844 17.2813 29.9961 19.9961 29.9961C22.7109 29.9961 23.0508 29.9844 24.1172 29.9375C25.1797 29.8906 25.9102 29.7188 26.543 29.4727C27.1992 29.2188 27.7578 28.875 28.3125 28.3203C28.8672 27.7656 29.2109 27.207 29.4648 26.5508C29.7109 25.9141 29.8828 25.1875 29.9297 24.125C29.9766 23.0586 29.9883 22.7188 29.9883 20.0039C29.9883 17.2891 29.9766 16.9492 29.9297 15.8828C29.8828 14.8203 29.7109 14.0898 29.4648 13.457C29.2188 12.793 28.8789 12.2344 28.3203 11.6797C27.7656 11.125 27.207 10.7813 26.5508 10.5273C25.9141 10.2812 25.1875 10.1094 24.125 10.0625C23.0547 10.0117 22.7148 10 20 10Z"
          fill="currentColor"
        />
        <path
          d="M20 14.8633C17.1641 14.8633 14.8633 17.1641 14.8633 20C14.8633 22.8359 17.1641 25.1367 20 25.1367C22.8359 25.1367 25.1367 22.8359 25.1367 20C25.1367 17.1641 22.8359 14.8633 20 14.8633ZM20 23.332C18.1602 23.332 16.668 21.8398 16.668 20C16.668 18.1602 18.1602 16.668 20 16.668C21.8398 16.668 23.332 18.1602 23.332 20C23.332 21.8398 21.8398 23.332 20 23.332Z"
          fill="currentColor"
        />
        <path
          d="M26.5391 14.6602C26.5391 15.3242 26 15.8594 25.3398 15.8594C24.6758 15.8594 24.1406 15.3203 24.1406 14.6602C24.1406 13.9961 24.6797 13.4609 25.3398 13.4609C26 13.4609 26.5391 14 26.5391 14.6602Z"
          fill="currentColor"
        />
      </g>
    </g>
    <rect
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="currentColor"
    />
    <defs>
      <clipPath id="clip0_6547_29076">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
      <clipPath id="clip1_6547_29076">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
